import Link from 'next/link';
import * as S from './AuthorBlock.styles';
import emptyImg from '@/shared/images/Images/default-avatar.webp';

type TAuthorBlockProps = {
    authorImage: string;
    authorName: string;
    authorSlug: string;
    description: string;
};

export const AuthorBlock = ({
    authorImage,
    authorName,
    authorSlug,
    description,
}: TAuthorBlockProps) => {
    if (!authorName) {
        return <></>;
    }

    return (
        <S.Container>
            <S.Title>About the Author</S.Title>
            <S.ContentBlock>
                <S.AuthorImage>
                    <S.MainImage
                        src={authorImage}
                        width="100px"
                        height="100px"
                        alt="Author photo"
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = emptyImg.src;
                        }}
                    />
                </S.AuthorImage>
                <S.Content>
                    <S.AuthorName>{authorName}</S.AuthorName>
                    <S.Description>{description}</S.Description>
                    <Link href={`/blog/authors/${authorSlug}/`} passHref>
                        <S.AuthorLink>
                            {`More ${authorName.split(' ')[0]}'s articles`}
                            <S.Arrow />
                        </S.AuthorLink>
                    </Link>
                </S.Content>
            </S.ContentBlock>
        </S.Container>
    );
};
